import type { JobTriggerState } from ".."

const parseValidDate = (value: Date | string | null | undefined) => {
  if (!value) return null

  const parsed = value instanceof Date ? value : new Date(value)

  return Number.isNaN(parsed.getTime()) ? null : parsed
}

const formatCooldownUntil = (date: Date) =>
  new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    timeZone: "UTC",
    year: "numeric"
  }).format(date)

export type TriggerViewState = {
  actionLabel: string
  disabledReason?: string | null
  errorMessage?: string | null
  isDisabled: boolean
  isRunning: boolean
  statusText: string
  title: string
}

export const useTriggerViewState = ({
  actionLabel,
  now,
  title,
  trigger
}: {
  actionLabel: string
  now: Date
  title: string
  trigger: JobTriggerState
}): TriggerViewState => {
  const cooldownUntil = parseValidDate(trigger.cooldownUntil)
  const isInCooldown = cooldownUntil
    ? cooldownUntil.getTime() > now.getTime()
    : false

  const isDisabled =
    trigger.isRunning || isInCooldown || Boolean(trigger.disabledReason)

  let statusText = "Ready"

  if (trigger.errorMessage) {
    statusText = trigger.errorMessage
  } else if (trigger.isRunning) {
    statusText = "Running…"
  } else if (isInCooldown && cooldownUntil) {
    statusText = `Cooldown until ${formatCooldownUntil(cooldownUntil)}`
  } else if (trigger.disabledReason) {
    statusText = "Unavailable"
  }

  return {
    actionLabel,
    disabledReason: trigger.disabledReason,
    errorMessage: trigger.errorMessage,
    isDisabled,
    isRunning: trigger.isRunning,
    statusText,
    title
  }
}
